import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EventClassResponse, EventClassRegistrationResponse} from '../../../../../../../../../../@shared/models/response.module';
import {formatDateDMYDots} from '../../../../../../../../../../@core/utils/utils.service';
import {DeleteModal} from '../../../../../../../../../../@shared/components/delete-modal/delete-modal';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {ToastService} from '../../../../../../../../../../@core/services/toast.service';
import {EditRegistration} from './components/edit-registration/edit-registration';
import {AQH_EVE_32, AQH_EVE_6} from '../../../../../../../../../../@shared/models/input.module';
import {StorageService} from '../../../../../../../../../../@core/services/storage.service';

@Component({
  selector: 'app-view-class-registrations',
  standalone: false,
  templateUrl: './view-class-registrations.html',
  styleUrl: './view-class-registrations.css'
})
export class ViewClassRegistrations implements OnInit {
  @Input() eventClass!: EventClassResponse;
  loading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private eventsService: EventsService,
    private toastService: ToastService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    console.log('Event Class with Registrations:', this.eventClass);
  }

  reloadEventClass() {
    if (!this.eventClass) return;

    this.loading = true;
    const payload: AQH_EVE_6 = {
      event_id: this.eventClass.event_id
    };

    this.eventsService.getEventClasses(payload).subscribe({
      next: (classes: EventClassResponse[]) => {
        // Find and update the current event class
        const updatedClass = classes.find(c => c.event_class_id === this.eventClass.event_class_id);
        if (updatedClass) {
          this.eventClass = updatedClass;
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toastService.error('Failed to reload registration data');
      }
    });
  }

  close() {
    this.activeModal.close();
  }

  getRegistrationNumber(index: number): number {
    return index + 1;
  }

  openEditRegistrationModal(registration: EventClassRegistrationResponse) {
    const modalRef = this.modalService.open(EditRegistration, { size: 'lg', centered: true });
    modalRef.componentInstance.registration = registration;

    modalRef.result.then((updated) => {
      if (updated) {
        // Reload the event class data to show updated registration
        this.reloadEventClass();
        // Also signal parent to refresh
        this.activeModal.close(true);
      }
    }, () => {
      // Modal dismissed
    });
  }

  deleteRegistration(registration: EventClassRegistrationResponse) {
    const modalRef = this.modalService.open(DeleteModal, { size: 'md', centered: true });
    modalRef.result.then((confirmed) => {
      if (confirmed) {
        const payload: AQH_EVE_32 = {
          class_registration_id: registration.class_registration_id,
          user_id: this.storageService.getUser().user_id
        };

        this.eventsService.cancelEventClassRegistration(payload).subscribe({
          next: () => {
            this.toastService.success('Registration cancelled successfully');
            // Remove the registration from the list
            const index = this.eventClass.event_class_registrations.findIndex(
              r => r.class_registration_id === registration.class_registration_id
            );
            if (index > -1) {
              this.eventClass.event_class_registrations.splice(index, 1);
            }
          },
          error: () => {
            this.toastService.error('Failed to cancel registration');
          }
        });
      }
    }, () => {
      // Modal dismissed
    });
  }

  protected readonly formatDateDMYDots = formatDateDMYDots;
}
